<div class="container-cynnwys">
  @for (rhybudd of rhybuddion; track rhybudd) {
  <div class="neges {{cssClass(rhybudd)}} mb-4 p-3 alert-dismissable">
    <a class="cau" (click)="dileuRhybudd(rhybudd)"><fa-icon class="mr-2" icon="times"></fa-icon></a>
    {{ rhybudd.neges | translate }}
  </div>
  }
</div>
